import { useState, useEffect, useContext } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { API_ROUTES } from 'routes/api';
import { NotificationContext } from 'context/NotificationContext';
import imonitor from 'assets/images/imonitor.svg';
import logo from 'assets/images/cosbots-logo.png';
import { CogIcon, EyeIcon, EyeOffIcon } from '@heroicons/react/outline';
import axios from 'axios';
import { PasswordGuidePopover } from 'components/PasswordGuide';
import clsx from 'clsx';

export default function ForgotPassword() {
  const [details, setDetails] = useState({});
  const [formRequested, setFormRequested] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [passwordValid, setPasswordValid] = useState(false);

  const [inputType, setInputType] = useState('password');

  let { setNotification } = useContext(NotificationContext);
  let history = useHistory();

  function forgot() {
    setLoading(true);
    if (formRequested) {
      axios
        .put(API_ROUTES.AUTHENTICATION.FORGOT_PASSWORD, details)
        .then((res) => {
          setNotification({
            show: true,
            title: 'Password Reset',
            message: `Your password has been successfully reset.`,
            type: 'success',
          });
          history.push('/');
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      axios
        .post(API_ROUTES.AUTHENTICATION.PASSWORD_TOKEN, details)
        .then((res) => {
          if (res.data.token === undefined || res.data.token === null) {
            setDetails((prevState) => ({
              ...prevState,
              [`token`]: '',
            }));
          } else {
            setDetails((prevState) => ({
              ...prevState,
              [`token`]: res.data.token,
            }));
          }
          setNotification({
            show: true,
            title: 'Request sent',
            message: `Please check your email for OTP.`,
            type: 'success',
          });
          setFormRequested(true);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  }

  const renderPasswordInput = () => (
    <div>
      <label
        htmlFor="password"
        className="block text-sm font-medium text-gray-700"
      >
        New Password
      </label>
      <div className="mt-1">
        <div className="mt-2 flex rounded-md shadow-sm">
          <PasswordGuidePopover password={details.password || ''} onValidate={(isValid) => setPasswordValid(isValid)}>
            <input
              id="password"
              name="password"
              autoComplete="new-password"
              type={inputType}
              defaultValue={''}
              required
              className="appearance-none block w-full px-3 py-2 border rounded-l-md rounded-r-none border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              onChange={(event) => {
                setDetails((prevState) => ({
                  ...prevState,
                  [`password`]: event.target.value,
                }));
              }}
              value={details.password}
            />
          </PasswordGuidePopover>
          <span className="cursor-pointer inline-flex items-center rounded-r-md border border-l-0 border-gray-300 px-3 text-gray-500 sm:text-sm">
            {inputType === 'password' ? (
              <EyeIcon onClick={() => setInputType('text')} className={'h-4'} />
            ) : (
              <EyeOffIcon
                onClick={() => setInputType('password')}
                className={'h-4'}
              />
            )}
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            className="mx-auto h-12 w-auto"
            src={imonitor}
            alt="iMonitor Logo"
          />
          <img
            className="mx-auto h-12 w-auto mt-5"
            src={logo}
            alt="Cosbots Logo"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to iMonitor
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10 border-2">
            {!formSubmitted ? (
              <form
                className="mt-8 space-y-6"
                autocomplete="off"
                onSubmit={(event) => {
                  event.preventDefault();
                  forgot();
                }}
                method="POST"
              >
                <div className="space-y-1">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Email address
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={(event) => {
                          setDetails((prevState) => ({
                            ...prevState,
                            [`email`]: event.target.value,
                          }));
                        }}
                        value={details?.email}
                      />
                    </div>
                  </div>
                  {formRequested && (
                    <>
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700"
                        >
                          OTP
                        </label>
                        <input
                          id="otp"
                          name="otp"
                          type="otp"
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          onChange={(event) => {
                            setDetails((prevState) => ({
                              ...prevState,
                              [`otp`]: event.target.value,
                            }));
                          }}
                          value={details?.otp}
                        />
                      </div>

                      {renderPasswordInput()}
                    </>
                  )}
                </div>

                <div>
                  <button
                    type="submit"
                  
                    disabled={loading || (!passwordValid && formRequested)}
                    className={clsx("w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500", {
                      'hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500': passwordValid && formRequested,
                      'disabled:cursor-not-allowed': !passwordValid && formRequested,
                    })}
                  >
                    {loading ? (
                      <CogIcon className="animate-spin h-6 w-6 content-center text-center mx-auto" />
                    ) : (
                      <>{formRequested ? 'Submit' : 'Request OTP'}</>
                    )}
                  </button>
                </div>
              </form>
            ) : (
              <>
                <div>
                  <button
                    type="button"
                    onClick={() => {
                      setFormSubmitted(false);
                      setFormRequested(false);
                    }}
                    className="button m-auto"
                  >
                    Submit Again
                  </button>
                </div>
              </>
            )}

            <div className="flex items-center justify-between text-center mt-2 text-center">
              <div className="text-sm text-center">
                <NavLink
                  to={'/login'}
                  className="font-medium text-center text-indigo-600 hover:text-indigo-500"
                >
                  Return to login
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
